import type { ChatFile } from "types/chat.type";
import type { FileAttach, Message } from "types/message";
import { $urlImage } from "utils/url";

export const mapFileAttachToChatFile = (attach: FileAttach): ChatFile => ({
  id: String(attach.id),
  name: attach.originalName || attach.fileName,
  url: $urlImage(attach.filePath),
  kind: attach.mimeType?.startsWith("image/") ? "image" : "file",
});

export const normalizeMessage = (message: Message): Message => {
  const fileAttaches = message.fileAttaches ?? [];
  if (fileAttaches.length === 0) {
    return message;
  }

  return {
    ...message,
    files: fileAttaches.map(mapFileAttachToChatFile),
  };
};

export const normalizeMessages = (messages: Message[]): Message[] =>
  messages.map(normalizeMessage);
